import { Box, IconButton } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useCheckRoleAccess } from "shared/hooks/useCheckRoleAccess";
import Image from "shared/assets/index";
import SaveIcon from "@mui/icons-material/Save";
import { Spinner } from "shared/components";
import styles from "../../styles/provitionServiceDateField.module.scss";
import { SwalAlertContent } from "../SwalAlertContent";
import Swal from "sweetalert2";
import { createRoot } from "react-dom/client";
import { formatCurrency } from "shared/utils";
import { useSearchParams } from "react-router-dom";

interface Props {
  index: number;
  value: string;
  label: string;
  confirmUpdate: (currentValue: string) => Promise<any>;
  userRol: string[];
}

export const TotalValueField = ({
  index,
  value,
  label,
  confirmUpdate,
  userRol,
}: Props) => {
  const [, setParams] = useSearchParams();
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [userHasPermission, setUserHasPermission] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentValue, setcurrentValue] = useState<any>();
  const [totalValue, setTotalValue] = useState("");
  const modalTotalValue = document.createElement("div");
  const root = createRoot(modalTotalValue);

  const { checkRoles } = useCheckRoleAccess();

  const handleChange = (event: any) => {
    setcurrentValue(event.target.value);
  };

  const editButton = () => {
    return (
      <IconButton
        className={styles.editButton}
        onClick={() => {
          setIsEditing(!isEditing);
          setcurrentValue("");
        }}
        disableRipple
        data-testid="icon_edit"
      >
        <img src={Image.iconoEditar} alt="Editar" />
      </IconButton>
    );
  };

  const onSave = () => {
    // Mostrar diálogo de confirmación
    root.render(
      <SwalAlertContent
        description={`¿Está seguro de que desea actualizar el ${label} del contrato?`}
        onCancel={() => {
          Swal.clickCancel();
        }}
        onConfirm={async () => {
          try {
            const result = await confirmUpdate(currentValue);
            Swal.clickCancel();
            setIsEditing(false);
            // Solo aplicar formatCurrency si el label es "Valor total", no para "Número"
            if (label === "Valor total") {
              setTotalValue(formatCurrency(currentValue!));
            } else {
              setTotalValue(currentValue!);
            }
            setParams(`option=${0}`);
          } catch (error: any) {
            console.error("❌ Error calling confirmUpdate:", error);
            Swal.clickCancel();
            // Mostrar mensaje de error al usuario con el mensaje del backend
            Swal.fire({
              title: "Error",
              text:
                error?.response?.data?.message ||
                "Error al actualizar el número de contrato",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } finally {
            setIsLoading(false);
            setcurrentValue("");
          }
        }}
        textBtn="Sí"
        textCancel="No"
      />,
    );
    Swal.fire({
      title: "¡Atención!",
      icon: "warning",
      html: modalTotalValue,
      showCancelButton: false,
      showConfirmButton: false,
    });
  };

  useEffect(() => {
    setUserHasPermission(checkRoles(userRol));
  }, []);

  useEffect(() => {
    setTotalValue(value);
    return () => {
      setcurrentValue("");
      setTotalValue("");
    };
  }, [value]);

  return (
    <Fragment>
      {userHasPermission && isEditing ? (
        <Box
          className={styles.fieldEditionContainer}
          data-testid="field_edition_container"
        >
          <input
            data-testid={`input_value_${index}`}
            className={styles.inputDetails}
            type="text"
            onChange={handleChange}
            value={currentValue}
            placeholder={`Agregar nuevo ${label}`}
          />
          <Box className={styles.buttonsContainer}>
            {editButton()}

            <IconButton
              className={styles.saveButton}
              disableRipple
              onClick={onSave}
              data-testid="icon_save"
            >
              <SaveIcon />
            </IconButton>
          </Box>
        </Box>
      ) : (
        <>
          <Box
            className={styles.inputEditonDetailsContainer}
            data-testid="content_total_value"
          >
            <input
              data-testid={`input_value_${index}`}
              className={styles.inputDetails}
              type="text"
              disabled
              value={totalValue}
            />
            {userHasPermission && editButton()}
          </Box>
        </>
      )}
      {isLoading && <Spinner />}
    </Fragment>
  );
};
